import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

import { AppearanceProvider } from '@/app/appearance/AppearanceProvider';
import { createQueryClient } from '@/app/queryClient';

import type { Platform } from './platform';
import SignupPage from './SignupPage';

/**
 * Domaine principal (ex. gestclinic.bf, ou localhost en local) : aucune donnée de clinique,
 * seulement l'inscription. Chaque clinique travaille ensuite sur sa propre adresse.
 */
export default function MainSiteApp({ platform }: { platform: Platform }) {
  const [queryClient] = useState(createQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      <AppearanceProvider remote={false}>
        <SignupPage platform={platform} />
      </AppearanceProvider>
    </QueryClientProvider>
  );
}
